﻿export const AppContainerId = 'veilederomgjoringbasislan';
export const BoksA = 'boks-a';
export const BoksB = 'boks-b';
export const BoksBx = 'boks-bx';
export const BoksResultat = 'resultat';
